import { createContext, useContext, useState, useMemo, ReactNode } from 'react';

export type AccountType = 'myAccount' | 'subAccounts';

interface AccountTypeContextType {
    accountType: AccountType;
    setAccountType: (type: AccountType) => void;
    showAccountTypeSelector: boolean;
    setShowAccountTypeSelector: (show: boolean) => void;
}

const AccountTypeContext = createContext<AccountTypeContextType | undefined>(
    undefined
);

export const useAccountType = () => {
    const context = useContext(AccountTypeContext);
    if (!context) {
        throw new Error(
            'useAccountType must be used within an AccountTypeProvider'
        );
    }
    return context;
};

export const AccountTypeProvider = ({ children }: { children: ReactNode }) => {
    const [accountType, setAccountType] = useState<AccountType>('myAccount');
    const [showAccountTypeSelector, setShowAccountTypeSelector] =
        useState<boolean>(false);

    const value = useMemo(
        () => ({
            accountType,
            setAccountType,
            showAccountTypeSelector,
            setShowAccountTypeSelector,
        }),
        [accountType, showAccountTypeSelector]
    );

    return (
        <AccountTypeContext.Provider value={value}>
            {children}
        </AccountTypeContext.Provider>
    );
};
